module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/collegiate-starts-2-medium-1e7fe4d4e2795908e0bba6ebab44d8f0.jpg";